// extracted by mini-css-extract-plugin
export default {"userInfoBlock":"UserInfo_userInfoBlock__PxUvZ","notHovered":"UserInfo_notHovered__zlP7A","short":"UserInfo_short__U1Zuz","textBlock":"UserInfo_textBlock__XnfxA"};